import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { TournamentProvider } from './context/TournamentContext';
import HomePage from './components/HomePage'; // Create this component
import CreateTournament from './components/TournamentForm'; // Assuming TournamentForm is your create tournament page
import FetchTournaments from './components/TournamentList'; // Assuming TournamentList is for fetching tournaments
import Login from './components/loginPage';
import WithdrawRequest from './components/WithdrawRequest'
import UserWallet from './components/UserWallet'
import CreateAdmin from './components/CreateAdmin'
import CreateTrainer from './components/CreateTrainer'
import CreateTeam from './components/createTeam';
import TeamManage from './components/teamManage';
import AdminViewTournaments from './components/AdminViewTournaments';
import AdminViewUsers from './components/AdminViewUsers';
import TrainerProfile from './components/TrainerProfile';
import VideoLessons from './components/VideoLessons';
import UserPortal from './components/UserPortal';
import Subscription from './components/Subscription';
import ForgotPassword from './components/ForgotPassword';
import ChangePassword from './components/ChangePassword';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UpdatePassword from './components/ResetPassword';
import CreateSubscriptionPlan from './components/CreateSubscription';
import ManageSubscriptions from './components/ManageSubscription';
import CreateBlog from './components/CreateBlog';
import ManageBlogs from './components/ManageBlogs';
import CreatePolicy from './components/CreatePolicy';
import ManagePolicy from './components/ManagePolicy';
import ProtectedRoute from './components/ProtectedRoute';
import Unauthorized from './components/Unauthorized';
import { ADMIN_ROLES, ROLES } from './utils/auth';

const SUPERADMIN_ONLY = [ROLES.SUPERADMIN];
const ADMIN_ONLY = [ROLES.ADMIN];
const TRAINER_ONLY = [ROLES.TRAINER];
const SUPERADMIN_OR_TRAINER = [ROLES.SUPERADMIN, ROLES.TRAINER];

const App = () => {
  return (
    <TournamentProvider>
      <Router>
         <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
        />
        <div style={{ padding: '20px' }}>
          <Routes>
            {/* Public */}
            <Route path="/" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<UpdatePassword />} />
            <Route path="/unauthorized" element={<Unauthorized />} />

            {/* Mobile-app user portal: guarded separately by its own
                `userPortalAccessToken`, not by the admin session. */}
            <Route path="/user-portal" element={<UserPortal />} />
            <Route path="/subscription" element={<Subscription />} />

            {/* Any signed-in admin-panel user */}
            <Route path="/Dashboard" element={<ProtectedRoute element={<HomePage />} allowedRoles={ADMIN_ROLES} />} />
            <Route path="/change-password" element={<ProtectedRoute element={<ChangePassword />} allowedRoles={ADMIN_ROLES} />} />
            <Route path="/withdraw-request" element={<ProtectedRoute element={<WithdrawRequest />} allowedRoles={ADMIN_ROLES} />} />
            <Route path="/user-wallet" element={<ProtectedRoute element={<UserWallet />} allowedRoles={ADMIN_ROLES} />} />

            {/* Super admin */}
            <Route path="/create-admin" element={<ProtectedRoute element={<CreateAdmin />} allowedRoles={SUPERADMIN_ONLY} />} />
            <Route path="/create-subscription" element={<ProtectedRoute element={<CreateSubscriptionPlan />} allowedRoles={SUPERADMIN_ONLY} />} />
            <Route path="/manage-subscription" element={<ProtectedRoute element={<ManageSubscriptions />} allowedRoles={SUPERADMIN_ONLY} />} />
            <Route path="/create-blog" element={<ProtectedRoute element={<CreateBlog />} allowedRoles={SUPERADMIN_ONLY} />} />
            <Route path="/edit-blog/:id" element={<ProtectedRoute element={<CreateBlog />} allowedRoles={SUPERADMIN_ONLY} />} />
            <Route path="/manage-blogs" element={<ProtectedRoute element={<ManageBlogs />} allowedRoles={SUPERADMIN_ONLY} />} />
            <Route path="/create-policy" element={<ProtectedRoute element={<CreatePolicy />} allowedRoles={SUPERADMIN_ONLY} />} />
            <Route path="/edit-policy/:id" element={<ProtectedRoute element={<CreatePolicy />} allowedRoles={SUPERADMIN_ONLY} />} />
            <Route path="/manage-policy" element={<ProtectedRoute element={<ManagePolicy />} allowedRoles={SUPERADMIN_ONLY} />} />

            {/* Super admin + trainer */}
            <Route path="/create-team" element={<ProtectedRoute element={<CreateTeam />} allowedRoles={SUPERADMIN_OR_TRAINER} />} />
            <Route path="/team-manage" element={<ProtectedRoute element={<TeamManage />} allowedRoles={SUPERADMIN_OR_TRAINER} />} />
            <Route path="/create-tournament" element={<ProtectedRoute element={<CreateTournament />} allowedRoles={SUPERADMIN_OR_TRAINER} />} />
            <Route path="/fetch-tournaments" element={<ProtectedRoute element={<FetchTournaments />} allowedRoles={SUPERADMIN_OR_TRAINER} />} />

            {/* Admin */}
            <Route path="/create-trainer" element={<ProtectedRoute element={<CreateTrainer />} allowedRoles={ADMIN_ONLY} />} />
            <Route path="/admin-view-tournaments" element={<ProtectedRoute element={<AdminViewTournaments />} allowedRoles={ADMIN_ONLY} />} />
            <Route path="/admin-view-users" element={<ProtectedRoute element={<AdminViewUsers />} allowedRoles={ADMIN_ONLY} />} />

            {/* Trainer */}
            <Route path="/trainer-profile" element={<ProtectedRoute element={<TrainerProfile />} allowedRoles={TRAINER_ONLY} />} />
            <Route path="/video-lessons" element={<ProtectedRoute element={<VideoLessons />} allowedRoles={TRAINER_ONLY} />} />

            <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
        </div>
      </Router>
    </TournamentProvider>
  );
};

export default App;
